import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Lock, CheckCircle2 } from "lucide-react";
import { Toaster, toast } from "sonner";
import api, { readError } from "./api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Şifre en az 6 karakter olmalı");
    if (password !== confirm) return toast.error("Şifreler eşleşmiyor");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Şifre değiştirildi");
      setTimeout(() => nav("/login", { replace: true }), 1500);
    } catch (err) {
      toast.error(readError(err, "İşlem başarısız"));
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return <div className="login-wrap"><div className="login-card"><h1>Geçersiz bağlantı</h1><p>Bağlantıda token yok.</p></div></div>;
  }

  return (
    <div className="login-wrap">
      <div className="login-card" data-testid="reset-card">
        <div className="login-brand">
          <div className="login-mark">CDS</div>
          <h1>Şifre sıfırlama</h1>
          <p>{done ? "Şifreniz güncellendi, giriş sayfasına yönlendiriliyorsunuz..." : "Yeni şifrenizi belirleyin"}</p>
        </div>
        {done ? (
          <div className="reset-done"><CheckCircle2 size={40} /></div>
        ) : (
          <form onSubmit={submit} className="login-form">
            <label>
              <Lock size={14} /> Yeni şifre
              <input data-testid="reset-password" type="password" required minLength={6}
                value={password} onChange={e => setPassword(e.target.value)} autoFocus />
            </label>
            <label>
              <Lock size={14} /> Tekrar
              <input data-testid="reset-confirm" type="password" required minLength={6}
                value={confirm} onChange={e => setConfirm(e.target.value)} />
            </label>
            <button data-testid="reset-submit" className="primary-button login-submit" type="submit" disabled={busy}>
              {busy ? "Kaydediliyor..." : "Şifreyi değiştir"}
            </button>
          </form>
        )}
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
}
